"use client";

import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

export function Nav() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const navLinks = [
    { name: "Showcase", id: "showcase" },
    { name: "Features", id: "features" },
    { name: "Gallery", id: "gallery" },
    { name: "Reviews", id: "reviews" },
  ];

  return (
    <header className="absolute top-0 left-0 right-0 z-30">
      <motion.div 
        className="mx-auto max-w-7xl px-6 lg:px-10 h-24 flex items-center justify-between gap-8"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.21, 0.47, 0.32, 0.98] }}
      >
        <a 
          href="#" 
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="text-2xl font-bold tracking-tighter text-foreground shrink-0"
        >
          Apollo<span className="text-primary">.</span>
        </a>

        <nav className="hidden md:block flex-1">
          <ul className="flex items-center justify-center gap-8">
            {navLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  onClick={(e) => scrollToSection(e, link.id)}
                  className="text-xs uppercase tracking-[0.2em] font-bold text-foreground/60 hover:text-primary transition-colors"
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        
        <div className="shrink-0">
          <Button 
            size="lg" 
            className="rounded-full bg-[#0055FF] hover:bg-[#0044DD] text-white font-bold px-8 shadow-lg shadow-blue-500/20"
            asChild
          >
            <a href="#pricing" onClick={(e) => scrollToSection(e, "pricing")}>ORDER NOW</a>
          </Button>
        </div>
      </motion.div>
    </header>
  );
}
